export default "__VITE_ASSET__DpDxqtL___"